import { BasedObservedViewModel } from "app/based/basedObservedViewModel/BasedObservedViewModel";
import { VnskySupportAlertInjection } from "features/vnskySupportAlert/di/VnskySupportAlertInjection";
import { AlertSupportRequestEntity } from "features/vnskySupportAlert/domain/entities/AlertSupportRequestEntity";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { IAlertSupportObservedState } from "../interfaces/IVnskySupportAlert";

class VnskySupportAlertInput implements Disposable {
  public fetchList = new BehaviorSubject<AlertSupportRequestEntity>(undefined);

  [Symbol.dispose](): void {
    this.fetchList.complete();
  }
}

class VnskySupportAlertOutput implements Disposable {
  public onError = new BehaviorSubject<string>("");

  [Symbol.dispose](): void {
    this.onError.complete();
  }
}

@injectable()
export class VnskySupportAlertViewModel extends BasedObservedViewModel<
  VnskySupportAlertInput,
  VnskySupportAlertOutput,
  IAlertSupportObservedState
> {
  constructor() {
    super(new VnskySupportAlertInput(), new VnskySupportAlertOutput());
  }

  private useCase = VnskySupportAlertInjection.getUseCase();

  protected override createObservedState(): IAlertSupportObservedState {
    return {
      detail: {},
      list: [],
      loading: false,
      pagination: {},
    };
  }

  protected override transform(): void {
    this.skipFirstInitial(this.input.fetchList, async (params, guard) => {
      try {
        guard?.runIfLatest(() => this.setObservedState({ loading: true }));
        const res = await this.useCase.getAlerts(params);
        this.setObservedState({ list: res?.data || [] });
        this.setObservedState({ pagination: res?.pagination || {} });
      } catch (error) {
        console.error(error);
        this.output.onError.next(error?.message);
        this.setObservedState({
          list: [],
          pagination: {},
        });
      } finally {
        guard?.runIfLatest(() => this.setObservedState({ loading: false }));
      }
    });
  }
}
